import React from "react";
import ReactDOM from "react-dom/client";
import { CssBaseline, ThemeProvider } from "@mui/material";
import App from "./App.tsx";
import ImeiProvider from "./store/ImeiProvider.tsx";
import { customTheme } from "./util/constants.ts";
import "./assets/fonts/sohne_stylesheet.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";

/* COSMOPL-2162 Decided to remove RUM. */
// import { datadogRum } from '@datadog/browser-rum';

// // Initialize Datadog RUM
// datadogRum.init({
//   applicationId: import.meta.env.VITE_DD_ACTIVATION_APP_ID,
//   clientToken: import.meta.env.VITE_DD_ACTIVATION_APP_CLIENT_TOKEN,
//   site: 'datadoghq.com',
//   service: 'activation-app',
//   version: '1.0.0',
//   env: import.meta.env.VITE_APP_ENV|| 'development',
//   sessionSampleRate: 100,
//   sessionReplaySampleRate: 100,
//   trackResources: true,
//   trackLongTasks: true,
//   trackUserInteractions: true,
//   defaultPrivacyLevel: 'mask-user-input',
// });

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ImeiProvider>
      <ThemeProvider theme={customTheme}>
        <CssBaseline />
        <App />
      </ThemeProvider>
    </ImeiProvider>
  </React.StrictMode>
);
